/**
 * PDP video hero (mobile): CTA taps scroll via scrollIntoView so CSS scroll-margin matches the browser;
 * inline scroll-margin is raised to the live #header height when the header is taller than theme vars.
 * Full reload: keep viewport on the hero (no browser scroll restore into the PDP carousel).
 */
(function () {
  var MQ = '(max-width: 63.99875em)';

  function hasVideoHero() {
    return document.querySelector('.pdp-video-hero-section');
  }

  function stripHeroCtaHash() {
    try {
      if (!document.querySelector('.pdp-video-hero-section')) return;
      var h = window.location.hash;
      var hl = h.toLowerCase();
      if (hl === '#pdp-product-top' || hl === '#pdp-product-media-carousel') {
        history.replaceState(null, '', location.pathname + location.search);
      }
    } catch (e) {
      /* ignore */
    }
  }

  stripHeroCtaHash();

  function hashAllowsDeepLink() {
    var h = window.location.hash;
    return h && h.length > 1;
  }

  function heroScrollTarget() {
    return (
      document.querySelector('.shopify-section.pdp-video-hero-section-root') ||
      document.querySelector('.shopify-section:has(> section.pdp-video-hero-section)') ||
      document.querySelector('.pdp-video-hero-section')
    );
  }

  var heroScrollResetTimeouts = [];
  var heroScrollUserHandoff = false;

  function cancelHeroScrollResets() {
    heroScrollUserHandoff = true;
    for (var i = 0; i < heroScrollResetTimeouts.length; i++) {
      clearTimeout(heroScrollResetTimeouts[i]);
    }
    heroScrollResetTimeouts = [];
  }

  function scrollWindowToHeroTop() {
    if (heroScrollUserHandoff || !hasVideoHero() || hashAllowsDeepLink()) return;
    var ae = document.activeElement;
    if (
      ae &&
      ae !== document.body &&
      typeof ae.closest === 'function' &&
      ae.closest('.product-top__media-carousel')
    ) {
      if (typeof ae.blur === 'function') ae.blur();
    }
    var hero = heroScrollTarget();
    if (hero && typeof hero.scrollIntoView === 'function') {
      try {
        hero.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'auto',
        });
      } catch (err) {
        hero.scrollIntoView(true);
      }
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (err2) {
      window.scrollTo(0, 0);
    }
    var docEl = document.documentElement;
    if (docEl) docEl.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }

  var heroScrollResetScheduled = false;

  function scheduleHeroScrollResets() {
    stripHeroCtaHash();
    if (heroScrollUserHandoff || heroScrollResetScheduled) return;
    heroScrollResetScheduled = true;
    /* Short burst only: long timeouts + triple scheduling (pageshow/load/DOM) fought user scroll */
    var delays = [0, 50, 100, 200, 400];
    for (var i = 0; i < delays.length; i++) {
      (function (ms) {
        var id = window.setTimeout(function () {
          scrollWindowToHeroTop();
        }, ms);
        heroScrollResetTimeouts.push(id);
      })(delays[i]);
    }
  }

  var scrollHandoffOpts = { passive: true };
  window.addEventListener(
    'scroll',
    function onHeroScrollHandoff() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > 12) {
        cancelHeroScrollResets();
        window.removeEventListener('scroll', onHeroScrollHandoff, scrollHandoffOpts);
      }
    },
    scrollHandoffOpts
  );

  /* iOS often fires scroll late; cancel resets on first move so scroll-to-top doesn’t fight the gesture */
  var touchHandoffOpts = { capture: true, passive: true };
  window.addEventListener(
    'touchmove',
    function onHeroTouchHandoff() {
      if (!hasVideoHero()) return;
      cancelHeroScrollResets();
      window.removeEventListener('touchmove', onHeroTouchHandoff, touchHandoffOpts);
    },
    touchHandoffOpts
  );

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) return;
    stripHeroCtaHash();
    scheduleHeroScrollResets();
  });

  /* capture: true runs in capture phase before mfr-utils’ bubble load (hash → scrollIntoView) */
  window.addEventListener(
    'load',
    function () {
      stripHeroCtaHash();
      scheduleHeroScrollResets();
      requestAnimationFrame(function () {
        requestAnimationFrame(scrollWindowToHeroTop);
      });
    },
    true
  );

  function headerOffset() {
    var h = document.getElementById('header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  /**
   * Fallback offset when scrollIntoView isn’t used. Theme CSS vars can lag the live #header
   * (announcement bar, sticky state) — never scroll with an offset smaller than measured header.
   */
  function readScrollOffsetForTarget(el) {
    if (!el) return headerOffset();
    var sm = getComputedStyle(el).scrollMarginTop;
    var parsed = parseFloat(sm);
    if (isNaN(parsed) || parsed < 0) parsed = 0;
    var root = document.documentElement;
    var cs = getComputedStyle(root);
    var mob = parseFloat(cs.getPropertyValue('--top-offset-mobile')) || 0;
    var off = parseFloat(cs.getPropertyValue('--top-offset')) || 0;
    var fs = parseFloat(cs.fontSize) || 16;
    var fromVars = Math.max(mob, off, 6.5 * fs);
    return Math.round(Math.max(parsed, fromVars, headerOffset()));
  }

  function pushAnalytics(productId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pdp_video_hero_cta_click',
      product_id: productId,
    });
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'pdp_video_hero_cta_click', {
        product_id: productId,
      });
    }
  }

  function scrollToTarget(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;

    cancelHeroScrollResets();

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function measureAndScroll() {
      var hh = headerOffset();
      var prevMargin = target.style.scrollMarginTop;
      var csMargin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      /* Inline margin so scrollIntoView matches live header + CSS max(...) intent */
      target.style.scrollMarginTop = Math.max(csMargin, hh) + 'px';

      function clearMargin() {
        if (prevMargin) {
          target.style.scrollMarginTop = prevMargin;
        } else {
          target.style.removeProperty('scroll-margin-top');
        }
      }

      try {
        target.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: reduce ? 'auto' : 'smooth',
        });
      } catch (err) {
        clearMargin();
        var offsetY = readScrollOffsetForTarget(target);
        var rect = target.getBoundingClientRect();
        var y = Math.round(
          rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offsetY
        );
        y = Math.max(0, y);
        try {
          window.scrollTo({ top: y, left: 0, behavior: reduce ? 'auto' : 'smooth' });
        } catch (e2) {
          window.scrollTo(0, y);
        }
        return;
      }

      if (reduce) {
        requestAnimationFrame(function () {
          requestAnimationFrame(clearMargin);
        });
      } else {
        window.setTimeout(clearMargin, 1200);
      }
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(measureAndScroll);
    });
  }

  document.addEventListener('click', function (e) {
    if (!window.matchMedia(MQ).matches) return;
    var cta = e.target.closest('[data-pdp-video-hero-cta]');
    if (!cta) return;

    e.preventDefault();

    var productId = cta.getAttribute('data-product-id');
    if (productId) pushAnalytics(productId);

    var targetId = cta.getAttribute('data-scroll-target') || 'pdp-product-media-carousel';
    scrollToTarget(targetId);
  });

  /**
   * Mobile full-bleed hero video autoplays muted; unmute/mute control (desktop uses carousel dock).
   */
  function initMobileHeroSoundControl() {
    if (!window.matchMedia(MQ).matches) return;
    var section = document.querySelector('.pdp-video-hero-section');
    if (!section || section.getAttribute('data-hero-unmute-bound') === '1') return;
    var video = section.querySelector('video.pdp-video-hero-section__video-el');
    var btn = section.querySelector('.pdp-video-hero-section__unmute');
    if (!video || !btn) return;
    section.setAttribute('data-hero-unmute-bound', '1');

    function syncBtn() {
      var soundOn = !video.muted;
      btn.classList.toggle('pdp-video-hero-section__unmute--sound-on', soundOn);
      btn.setAttribute('aria-label', soundOn ? 'Mute video' : 'Unmute video');
    }

    function toggleMute() {
      if (video.muted) {
        video.defaultMuted = false;
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(syncBtn).catch(syncBtn);
        } else {
          syncBtn();
        }
      } else {
        video.muted = true;
        syncBtn();
      }
    }

    var lastTime = 0;
    video.addEventListener('timeupdate', function () {
      var t = video.currentTime;
      if (video.duration > 0 && !video.seeking && lastTime > 0.75 && t < lastTime - 0.35) {
        video.muted = true;
        syncBtn();
      }
      lastTime = t;
    });

    video.addEventListener('volumechange', syncBtn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMute();
    });
    syncBtn();
  }

  function runWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  runWhenReady(initMobileHeroSoundControl);
})();
